"use client";

import { useRef, useState, useEffect } from "react";
import Image from "next/image";
import Slider from "react-slick";

/*import "./CardShowcase.scss";*/
import Section from "../Section";

export type ResolvedCard = {
  title: string;
  image: { url: string };
  imageAlt: string;
  features: { title: string; description: string }[];
};

interface CardShowcaseClientProps {
  title?: string;
  cards: ResolvedCard[];
}

const CardShowcaseClient: React.FC<CardShowcaseClientProps> = ({
  title,
  cards,
}) => {
  const mediaQueryList = useRef<MediaQueryList | null>(null);
  const defaultSettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 1500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    pauseOnHover: true,
  };

  const [settings, setSettings] = useState(() => {
    if (typeof window !== "undefined") {
      const m = window.matchMedia("(max-width: 990px)");
      return {
        ...defaultSettings,
        slidesToShow: m.matches ? 1 : 2,
        arrows: !m.matches,
      };
    }

    return defaultSettings;
  });

  useEffect(() => {
    // Initialize media query list on client side only
    if (typeof window !== "undefined") {
      const mql = window.matchMedia("(max-width: 990px)");
      mediaQueryList.current = mql;

      function updateSettings(e: any) {
        setSettings((prevSettings) => ({
          ...prevSettings,
          slidesToShow: e.matches ? 1 : 2,
          arrows: !e.matches,
        }));
      }

      mql.addEventListener("change", updateSettings);

      return () => {
        mql.removeEventListener("change", updateSettings);
      };
    }
  }, []);

  return (
    <Section
      id="BiometricAccessControlPage"
      title={title || "Computer Vision AI for Industries"}
      className="pt-5"
    >
      <div className="card-showcase">
        <Slider {...settings}>
          {cards.map((item, index) => (
            <div className="col-12 col-md-6" key={index}>
              <div className="business-card">
                <div className="title-container">
                  <h3>{item.title}</h3>
                </div>
                <Image
                  src={item.image.url}
                  alt={item.imageAlt}
                  width={160}
                  height={160}
                />
                <div className="content-container">
                  <ul>
                    {item.features.map((feature, featureIdx) => (
                      <li key={featureIdx}>
                        <h5>{feature.title}</h5>
                        <p>{feature.description}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </Section>
  );
};

export default CardShowcaseClient;
